import { render, staticRenderFns } from "./CadastroDeRecurso.vue?vue&type=template&id=20532805&scoped=true&"
import script from "./CadastroDeRecurso.vue?vue&type=script&lang=js&"
export * from "./CadastroDeRecurso.vue?vue&type=script&lang=js&"
import style0 from "./CadastroDeRecurso.vue?vue&type=style&index=0&id=20532805&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20532805",
  null
  
)

export default component.exports